import { render, staticRenderFns } from "./DecorsDisplay.vue?vue&type=template&id=64dd0dec&scoped=true"
import script from "./DecorsDisplay.vue?vue&type=script&lang=js"
export * from "./DecorsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd0dec",
  null
  
)

export default component.exports